(function($) {
	// look-up-table: map of ch -> { value: Number, word: String, next: look-up-table }
	// lut is a look-up-table.
	var lut = {
		"j":{
			"value":0,
			"word":"January",
			"next":{
				"a":{
					"value":0,
					"word":"January",
					"next":{
						"n":{
							"value":0,
							"word":"January",
							"next":{
								"u":{
									"value":0,
									"word":"January",
									"next":{
										"a":{
											"value":0,
											"word":"January",
											"next":{
												"r":{
													"value":0,
													"word":"January",
													"next":{
														"y":{
															"value":0,
															"word":"January",
															"next":{}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				},
				"u":{
					"value":5,
					"word":"June",
					"next":{
						"n":{
							"value":5,
							"word":"June",
							"next":{
								"e":{
									"value":5,
									"word":"June",
									"next":{}
								}
							}
						},
						"l":{
							"value":6,
							"word":"July",
							"next":{
								"y":{
									"value":6,
									"word":"July",
									"next":{}
								}
							}
						}
					}
				}
			}
		},
		"f":{
			"value":1,
			"word":"February",
			"next":{
				"e":{
					"value":1,
					"word":"February",
					"next":{
						"b":{
							"value":1,
							"word":"February",
							"next":{
								"r":{
									"value":1,
									"word":"February",
									"next":{
										"u":{
											"value":1,
											"word":"February",
											"next":{
												"a":{
													"value":1,
													"word":"February",
													"next":{
														"r":{
															"value":1,
															"word":"February",
															"next":{
																"y":{
																	"value":1,
																	"word":"February",
																	"next":{}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"m":{
			"value":2,
			"word":"March",
			"next":{
				"a":{
					"value":2,
					"word":"March",
					"next":{
						"r":{
							"value":2,
							"word":"March",
							"next":{
								"c":{
									"value":2,
									"word":"March",
									"next":{
										"h":{
											"value":2,
											"word":"March",
											"next":{}
										}
									}
								}
							}
						},
						"y":{
							"value":4,
							"word":"May",
							"next":{}
						}
					}
				}
			}
		},
		"a":{
			"value":3,
			"word":"April",
			"next":{
				"p":{
					"value":3,
					"word":"April",
					"next":{
						"r":{
							"value":3,
							"word":"April",
							"next":{
								"i":{
									"value":3,
									"word":"April",
									"next":{
										"l":{
											"value":3,
											"word":"April",
											"next":{}
										}
									}
								}
							}
						}
					}
				},
				"u":{
					"value":7,
					"word":"August",
					"next":{
						"g":{
							"value":7,
							"word":"August",
							"next":{
								"u":{
									"value":7,
									"word":"August",
									"next":{
										"s":{
											"value":7,
											"word":"August",
											"next":{
												"t":{
													"value":7,
													"word":"August",
													"next":{}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"s":{
			"value":8,
			"word":"September",
			"next":{
				"e":{
					"value":8,
					"word":"September",
					"next":{
						"p":{
							"value":8,
							"word":"September",
							"next":{
								"t":{
									"value":8,
									"word":"September",
									"next":{
										"e":{
											"value":8,
											"word":"September",
											"next":{
												"m":{
													"value":8,
													"word":"September",
													"next":{
														"b":{
															"value":8,
															"word":"September",
															"next":{
																"e":{
																	"value":8,
																	"word":"September",
																	"next":{
																		"r":{
																			"value":8,
																			"word":"September",
																			"next":{}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"o":{
			"value":9,
			"word":"October",
			"next":{
				"c":{
					"value":9,
					"word":"October",
					"next":{
						"t":{
							"value":9,
							"word":"October",
							"next":{
								"o":{
									"value":9,
									"word":"October",
									"next":{
										"b":{
											"value":9,
											"word":"October",
											"next":{
												"e":{
													"value":9,
													"word":"October",
													"next":{
														"r":{
															"value":9,
															"word":"October",
															"next":{}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"n":{
			"value":10,
			"word":"November",
			"next":{
				"o":{
					"value":10,
					"word":"November",
					"next":{
						"v":{
							"value":10,
							"word":"November",
							"next":{
								"e":{
									"value":10,
									"word":"November",
									"next":{
										"m":{
											"value":10,
											"word":"November",
											"next":{
												"b":{
													"value":10,
													"word":"November",
													"next":{
														"e":{
															"value":10,
															"word":"November",
															"next":{
																"r":{
																	"value":10,
																	"word":"November",
																	"next":{}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"d":{
			"value":11,
			"word":"December",
			"next":{
				"e":{
					"value":11,
					"word":"December",
					"next":{
						"c":{
							"value":11,
							"word":"December",
							"next":{
								"e":{
									"value":11,
									"word":"December",
									"next":{
										"m":{
											"value":11,
											"word":"December",
											"next":{
												"b":{
													"value":11,
													"word":"December",
													"next":{
														"e":{
															"value":11,
															"word":"December",
															"next":{
																"r":{
																	"value":11,
																	"word":"December",
																	"next":{}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}

	// var dateFields = $([].slice.call($('input[type=date]')));

	var calendarFor = null;
	var cid = 0;
	var hideTimer = null;
	var clearButton = null;
	var cml = {};
	var cmd = {};

	function fillCalendar(selDate, date, cid, options) {
		var dFormat;
		var whichMode = options.mode;
		
		console.log('fillCalendar: ', whichMode);
		
		if (options.mode == 'datetime')
		{
			if (options.hideTime) {
				whichMode = options.hideTime() ? 'date' : 'datetime';
			}
		}
		if (whichMode == 'time') dFormat = 'g:i A';
		else if (whichMode == 'date') dFormat = 'F j, Y';
		else dFormat = 'F j, Y g:i A';
		
		if (whichMode != 'time') {
			var hs;
			if (cmd[cid] != date.format('Y-m')) {
				if (cml[date.format('Y-m')]) {
					$('#bs-calendar-' + cid).empty();
					hs = cml[date.format('Y-m')];
				} else {
					hs = ["<table class='picker-table table table-bordered'><tr><th>Su</th><th>Mo</th><th>Tu</th><th>We</th><th>Th</th><th>Fr</th><th>Sa</th></tr>"];
					var dd = new Date();
					dd.setTime(date.getTime());
					dd.setDate(1);
					dd.setDate(dd.getDate() - dd.getDay()); // Move to sunday of first week of month
					var de = new Date(date.getTime());
					de.setDate(1);
					de.setMonth(de.getMonth() + 1);
					de.setDate(0);
					while (de.getDay() != 0) de.setDate(de.getDate() + 1);
					// console.log(date, dd, de);
					
					while (dd <= de) {
						if (dd.getFullYear() > date.getFullYear() || (dd.getFullYear() == date.getFullYear() && dd.getMonth() > date.getMonth())) break;
						hs.push("<tr>");
						for (var i = 0; i < 7; i++) {
							if (dd.getMonth() != date.getMonth())
								hs.push("<td class='disabled'>" + dd.format("j") + "</td>");
							else {
								hs.push("<td data-day='" + dd.format('j') + "' ");
								if (dd.format("Ymd") == selDate.format('Ymd')) hs.push(" class='currentDay'");
								hs.push("><a href='#' data-date='" + dd.format("F j, Y") + "'>" + dd.format("j") + "</a></td>");
							}
							dd.setDate(dd.getDate() + 1);
						}
						hs.push("</tr>");
					}
					hs.push("</table>");
					cml[date.format('Y-m')] = hs.join("");
					hs = cml[date.format('Y-m')];
				}
				$('#bs-calendar-' + cid).html(hs);
				cmd[cid] = date.format('Y-m');
			}
			$('#bs-calendar-' + cid).find('.currentDay').removeClass('currentDay');
			$('#bs-calendar-' + cid).find('[data-day="' + selDate.format('j') + '"]').addClass('currentDay');
			
			$('#bs-calendar-' + cid).off('click').click(function() {
				$(calendarFor).focus();
			});
			$('#bs-calendar-' + cid).off('click', 'td:has(a)').on('click', 'td:has(a)', function(evt) {
				cmd[cid] = null;
				var d = new Date($(this).find('a').attr('data-date'));
				var e = new Date($(calendarFor).val());
				e.setDate(1);
				e.setMonth(0);
				e.setFullYear(d.getFullYear());
				e.setMonth(d.getMonth());
				e.setDate(d.getDate());
				$(calendarFor).val(e.format(dFormat)).change();
				evt.preventDefault();
				if (whichMode == 'datetime') {
					$(calendarFor).focus();
					fillCalendar(e, date, cid, options);
				} else {
					$(calendarFor).popover('destroy');
				}
			});
			$('#bs-calendar-' + cid + ' a').prop('tabIndex', -1);
		}
		
		if (whichMode != 'date') {
			$('#bs-calendar-time-' + cid).empty();
			
			var t0 = new Date('January 1 2001 12:00 AM');
			var td;
			
			if (options._durationComputedFrom) {
				if (typeof options.durationComputedFrom == 'function') {
					var cf = options.durationComputedFrom();
					if (!(cf instanceof Date)) cf = new Date(cf);
					if (!isNaN(cf)) options._durationComputedFrom = cf;
				}
				
				t0 = new Date(options._durationComputedFrom.getTime());
				td = new Date(t0.getTime());
				td.setHours(td.getHours() + 24);
			}
		
			var foundSelf = false;
			
			for (var hh = 0; hh < 24; hh++) {
				for (var mm = 0; mm < 60; mm += options.timeListStep) {
					var t1 = new Date(selDate.getTime());
					t1.setMinutes(0); t1.setHours(t0.getHours() + hh); t1.setMinutes(mm);				
	
					var tnx = new Date(t1.getTime());
					tnx.setMinutes(tnx.getMinutes() + options.timeListStep);
					var rr = document.createElement('a');
					$(rr).addClass('list-group-item').attr('data-time', t1.format('g:i A')).attr('href', 'javascript:void(0)');
					
					if (options._durationComputedFrom && t1 > t0 && t1 < td) {
						var ms = t1.getTime() - t0.getTime();
						var s = ms/1000;
						var m = Math.round(s/60);
						var mmv = m % 60;
						var h = (m - mmv) / 60;					
						var ff = [ ];
						if (h) ff.push(h + ' hour' + (h > 1 ? 's' : ''));
						if (mmv) ff.push(mmv + ' minute' + (mmv > 1 ? 's' : ''));
						$(rr).text(t1.format('g:i A') + ' (' + ff.join(', ') + ')');				
					} else {
						$(rr).text(t1.format('g:i A'));
					}
					if (t1.format('g:i A') == selDate.format('g:i A')) { foundSelf = true; $(rr).addClass('active'); }
					
					$('#bs-calendar-time-' + cid).append(rr);
					
					if (!foundSelf && tnx > selDate && selDate > t1) {
						var rr = document.createElement('div');
						$(rr).attr('data-time', selDate.format('g:i A'));
						
						if (options._durationComputedFrom && selDate > t0 && selDate < td) {
							var ms = selDate.getTime() - options._durationComputedFrom.getTime();
							var s = ms/1000;
							var m = Math.round(s/60);
							var mmv = m % 60;
							var h = (m - mmv) / 60;					
							var ff = [ ];
							if (h) ff.push(h + ' hour' + (h > 1 ? 's' : ''));
							if (mmv) ff.push(mmv + ' minute' + (mmv > 1 ? 's' : ''));
							if (ff.length)
								$(rr).text(selDate.format('g:i A') + ' (' + ff.join(', ') + ')');				
							else
								$(rr).text(selDate.format('g:i A'));
						} else {
							$(rr).text(selDate.format('g:i A'));
						}
						$(rr).addClass('list-group-item active').attr('href', 'javascript:void(0)');
						$('#bs-calendar-time-' + cid).append(rr);
					}
				}
			}
			$('#bs-calendar-time-' + cid).off('click', '[data-time]').on('click', '[data-time]', function(evt) {
				cmd[cid] = null;
				var d = new Date('January 1 2000 ' + $(this).attr('data-time'));
				console.log(this, d);
				var e;
				if (whichMode == 'time') e = d;
				else {
					e = new Date($(calendarFor).val());
					e.setMinutes(0);
					e.setHours(d.getHours());
					e.setMinutes(d.getMinutes());
				}
				$(calendarFor).val(e.format(dFormat)).change();
				evt.preventDefault();
				if (whichMode == 'datetime') {
					$(calendarFor).focus();
					fillCalendar(e, date, cid, options);
				} else {
					$(calendarFor).popover('destroy');
				}
			});
			
			var activeItem = $('#bs-calendar-time-' + cid + ' .active')[0];
			var pn = activeItem.parentNode;
			var pos = activeItem.offsetTop;
			var middle = pn.clientHeight / 2;	
			if (pos > middle) {
				pn.scrollTop = pos - middle;
			}
		}
	}
	function initCalendar(value, cid, options) {
		var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + value);
		if (isNaN(d)) d = new Date();
		var sd = new Date(d.getTime());
		$('#bs-cal-hdr-' + cid).off('click').click(function() { $(calendarFor).focus(); });
		$('#bs-cal-date-' + cid).text(d.format('F Y'));
		$('#bs-cal-next-' + cid).off('click').click(function() {
			d.setDate(1);
			d.setMonth(d.getMonth() + 1);
			$('#bs-cal-date-' + cid).text(d.format('F Y'));
			fillCalendar(sd, d, cid, options);
			$(calendarFor).focus();
		}).prop('tabIndex', -1);
		$('#bs-cal-prev-' + cid).off('click').click(function() {
			d.setDate(1);
			d.setMonth(d.getMonth() - 1);
			$('#bs-cal-date-' + cid).text(d.format('F Y'));
			fillCalendar(sd, d, cid, options);
			$(calendarFor).focus();
		}).prop('tabIndex', -1);
		fillCalendar(sd, d, cid, options);		
		$(calendarFor).trigger('resized-calendar.datetimepicker');
	}
	
	$.fn.datetimepicker = function(options) {
		var options1 = options;
		options = $.extend({
			durationComputedFrom: null,
			minuteStep: 15,
			minuteRoundStepTo: 15,
			timeListStep: 30,
			mode: 'datetime'			
		}, options || {});
		
		console.log(options1, options);
		
		function newInitialDate() {
			var d = new Date();
			d.setMinutes(options.minuteRoundStepTo * Math.round(d.getMinutes() / options.minuteRoundStepTo));
			return d;
		}
		
		if (this.length > 1) {
			this.each(function() { $(this).datetimepicker(options); });
			return this;
		}
		
		try { this.prop('readOnly', true).attr('type', 'text'); } catch (e) { ; }
		this.focus(function() {
			if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
			if (this == calendarFor) { return; }
			
			if (options.durationComputedFrom) {
				if (typeof options.durationComputedFrom == 'function')
					options._durationComputedFrom = options.durationComputedFrom();
				else
					options._durationComputedFrom = options.durationComputedFrom;
			
				if (!(options._durationComputedFrom instanceof Date))
					options._durationComputedFrom = new Date(options._durationComputedFrom);
				if (isNaN(options._durationComputedFrom)) options._durationComputedFrom = null;
			}
			
			cid++;
	
			var self = this;
			$(':input').on('focus.datepicker', function() {
				if (this == self) return;
	
				$(self).popover('destroy');
				$(':input').not(self).off('focus.datepicker');
			});			
	
			if (calendarFor) $(calendarFor).popover('destroy');
	
			var M = /MSIE (\d+)/.exec(navigator.userAgent);
			var is_oldIE = M && Number(M[1]) < 8;
			
			var S = {
				animation: true,
				html: true,
				placement: 'bottom',
				trigger: 'manual',
				template: [
					'<div class="popover bs-cal-datetime-popover" id="bs-cal-datetime-' + cid + '">',
						'<div class="arrow"></div>',
						'<h3 class="popover-title"></h3>',
						'<div class="popover-content"></div>',
					'</div>'
				].join(''),
				title: [
					'<div class="bs-cal-title ' + (options._durationComputedFrom ? 'withDuration' : '') + '">',
						'<div class="bs-cal-date-hdr" id="bs-cal-date-hdr-' + cid + '">',
							'<button id="bs-cal-prev-' + cid + '" class="bs-cal-prev pull-left btn btn-sm btn-default btn-no-pad" type="button" data-action="prev">&larr;</button>',
							'<button id="bs-cal-next-' + cid + '" class="bs-cal-next pull-right btn btn-sm btn-default btn-no-pad" type="button" data-action="next">&rarr;</button>',
							'<span class="bs-cal-date" id="bs-cal-date-' + cid + '"></span>',
							'<span style="clear: left;"></span>',
						'</div>',
						'<div id="bs-cal-time-hdr-' + cid + '" class="bs-cal-time-hdr">Time</div>',
					'</div>'
				].join(''),
				content: [
					'<div class="bs-calendar-content-full" id="bs-calendar-full-' + cid + '">',
						'<div id="bs-calendar-' + cid + '" class="bs-calendar"></div>',
						'<div id="bs-calendar-time-' + cid + '" class="list-group list-scrolling bs-calendar-time' + (options._durationComputedFrom ? ' withDuration' : '') + '"></div>',
						'<button type="button" class="btn btn-default close-button bs-calendar-done">Done</button>',
					'</div>'
				].join('')
			};
			var whichMode = options.mode;
			if (options.mode == 'datetime') {
				if (options.hideTime) {
					whichMode = options.hideTime() ? 'date' : 'datetime';
				}
			}
			
			console.log(options, whichMode);
			
			switch (whichMode) {
				case 'date':
					S.title = [
						'<div id="bs-cal-date-hdr-' + cid + '" class="bs-cal-date-hdr date">',
							'<button id="bs-cal-prev-' + cid + '" class="bs-cal-prev pull-left btn btn-sm btn-default btn-no-pad" type="button" data-action="prev">&larr;</button>',
							'<button id="bs-cal-next-' + cid + '" class="bs-cal-next pull-right btn btn-sm btn-default btn-no-pad" type="button" data-action="next">&rarr;</button>',
							'<span class="bs-cal-date" id="bs-cal-date-' + cid + '"></span>',
							'<span style="clear: left;"></span>',
						'</div>'
					].join('');
					S.content = [
						'<div class="bs-calendar-content-full" id="bs-calendar-full-' + cid + '">',
							'<div class="bs-calendar" id="bs-calendar-' + cid + '"></div>',
						'</div>'
					].join('');
					break;
				
				case 'time':
					S.title = '';
					S.content = [
						'<div class="bs-calendar-content-full" id="bs-calendar-full-' + cid + '">',
							'<div id="bs-calendar-time-' + cid + '" class="bs-calendar-time only-time list-group list-scrolling' + (options._durationComputedFrom ? ' withDuration' : '') + '"></div>',
						'</div>'
					].join('');
					break;
			}
			
			S.container = 'body';
			if ($(this).parents('.modal').length)
				S.container = $(this).parents('.modal').children('.modal-dialog');
			T=$(this).attr('title');
			$(this).removeAttr('title');
			$(this).popover(S).off('shown.bs.popover resized-calendar.datetimepicker').on('shown.bs.popover resized-calendar.datetimepicker', function(e) {
				$('#bs-calendar-full-' + cid + ' .close-button').click(function() {
					$(this).popover('destroy');
				});
				var e = $('#bs-cal-datetime-' + cid);
				var rp = e.offset().left + e.width();
				var ww = $(window).width();
				console.log(ww, rp);
				if (ww < rp) {
					var rd = rp - ww;
					rd += 140;
					console.log(rd);
					e.css('margin-left', (0 - rd));
					e.children('.arrow').css('margin-left', rd);
				}
				if (e.offset().left < 0) {
					var lp = e.offset().left + 140;
					e.css('margin-left', e.offset().left + 140);	
					e.children('.arrow').css('margin-left', 0 - lp);
				}
				
				var cr = e[0].getBoundingClientRect();
				var bp = cr.bottom;
				var wh = $(window).height();
				console.log(bp, wh);
				if (bp > wh) {
					// Can we place it above instead?
					var ecr = this.getBoundingClientRect();
					if ((ecr.top - cr.height) > 0) {
						$(e).css('top', $(this).offset().top - cr.height).removeClass('bottom').addClass('top');
					} else {
						var tgt = $(this).offset().top;
						needToMoveUp = 40 + (bp - wh), node = $(this);
						console.log(needToMoveUp);
						while (needToMoveUp > 0 && !node.is('html')) {
							if (node.css('overflow-y') != 'visible') {
								var sTop = node.scrollTop();
								node.scrollTop(sTop + needToMoveUp);
								console.log('Moved ', node[0], ' up ', (node.scrollTop() - sTop) + 'px');
								if (node.scrollTop() != (sTop + needToMoveUp)) {
									needToMoveUp -= (node.scrollTop() - sTop);
								}
							}
							node = node.parent();							
						}
						var tp = parseInt(e.css('top'));
						tp -= (40 + (bp - wh));
						e.css('top', tp);
					}
				}
			});
			if (T) $(this).attr('title', T);
			
			calendarFor = this;
			$(this).popover('show');
			var timer = null;
			var seg = 0;
			var segments, state = null;
			function selectSegment(date, field, validate) {
				// var segs = [ date.format('F'), date.format('j,'), date.format('Y'), date.format('g'), date.format('i'), date.format('A') ];
				if (validate) {
				}
				
				var segs = segments.map(function(v) {
					return v.render(date);
				});
				
				var startChar = 0;
				for (var i = 0; i < seg; i++) 
					startChar += segs[i].value.length + segs[i].after.length;
				var endChar = startChar + segs[seg].value.length;
				var b = segs.map(function(v) { return v.value + v.after; }).join('');
				if (b != field.value) {
					field.value = b;
					$(field).change();
				}
				setSelectionRange(field, startChar, endChar);
			}
			
			function previousSegment(element, event) {
				if ((seg - 1) >= 0) {
					seg--;
					state = segments[seg].initState();
					selectSegment(new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value), element, true);
					event.preventDefault();
				}
			}
			
			function nextSegment(element, event) {
				if ((seg + 1) < segments.length) {
					seg++;
					state = segments[seg].initState();
					selectSegment(new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value), element, true);
					event.preventDefault();
				}
			};
			
			segments = [
				/* Month */ {
					render: function(date) {
						return { value: date.format('F'), after: ' ' }
					},
					
					initState: function() {
						return {
							s: "",
							lutStack: []
						}
					},
					
					keypress: function(element, state, event) {
						if (event.type == 'backspace') {
							state.s = state.s.substring(0, state.s.length - 1);
							state.lutStack.pop();
						} else {
							if (String.fromCharCode(event.charCode) == ' ') {
								nextSegment(element, event);
								return;
							}
							var t = state.lutStack.length ? state.lutStack[state.lutStack.length - 1].next : lut;
							if (t[String.fromCharCode(event.charCode).toLowerCase()])
								state.lutStack.push(t[String.fromCharCode(event.charCode).toLowerCase()]);
							else if (lut[String.fromCharCode(event.charCode).toLowerCase()])
								state.lutStack = [ lut[String.fromCharCode(event.charCode).toLowerCase()] ];
						}
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						if (state.lutStack.length)
							d.setMonth(state.lutStack[state.lutStack.length - 1].value);
						
						selectSegment(d, element);
						initCalendar(element.value, cid, options);
						event.preventDefault();
					},

					increment: function(element, state) {
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setMonth(d.getMonth() + 1);
						state.s = "";
						state.lutStack = [];
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					},
					
					decrement: function(element, state) {
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setMonth(d.getMonth() - 1);
						state.s = "";
						state.lutStack = [];
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					}
				},
				
				/* Day */ {
					render: function(date) {
						return { value: date.format('j'), after: ', ' }
					},
					
					initState: function() {
						return {
							s: ""
						}
					},
					
					keypress: function(element, state, event) {
						if (event.type == 'backspace') {
							state.s = state.s.substring(0, state.s.length - 1);
						} else {
							if (String.fromCharCode(event.charCode) == ' ' || String.fromCharCode(event.charCode) == ',') {
								nextSegment(element, event);
								return;
							}
							
							if ('0'.charCodeAt(0) <= event.charCode && '9'.charCodeAt(0) >= event.charCode)
								state.s = String(state.s) + String.fromCharCode(event.charCode);
							if (state.s.length > 2)
								state.s = state.s.substring(state.s.length - 2);
						}
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						var eom = new Date(d.getTime());
						eom.setDate(1);
						eom.setMonth(eom.getMonth() + 1);
						eom.setDate(0);
						var ed = eom.getDate();
						if (Number(state.s) > ed) state.s = state.s.substring(1);
						d.setDate(Number(state.s));
						selectSegment(d, element);
						initCalendar(element.value, cid, options);
						event.preventDefault();
					},

					increment: function(element, state) {
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setDate(d.getDate() + 1);
						state.s = d.format('j');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					},
					
					decrement: function(element, state) {
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setDate(d.getDate() - 1);
						state.s = d.format('j');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					}
				},
				
				/* Year */ {
					render: function(date) {
						return { value: date.format('Y'), after: ' ' }
					},
					
					initState: function() {
						return {
							s: ""
						}
					},
					
					keypress: function(element, state, event) {
						if (event.type == 'backspace') {
							state.s = state.s.substring(0, state.s.length - 1);
						} else {
							if (String.fromCharCode(event.charCode) == ' ' || String.fromCharCode(event.charCode) == ',') {
								nextSegment(element, event);
								return;
							}
							
							if ('0'.charCodeAt(0) <= event.charCode && '9'.charCodeAt(0) >= event.charCode)
								state.s = String(state.s) + String.fromCharCode(event.charCode);
							if (state.s.length > 4)
								state.s = state.s.substring(state.s.length - 4);
						}
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();						
						var dd = new Date(d.getTime());
						dd.setFullYear(Number(state.s));
						while (isNaN(dd)) {
							state.s = state.s.substring(1);
							dd = new Date(d.getTime());
							dd.setFullYear(Number(state.s));
						}
						d.setFullYear(Number(state.s));
						selectSegment(d, element);
						initCalendar(element.value, cid, options);
						event.preventDefault();
					},
					
					increment: function(element, state) {
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setFullYear(d.getFullYear() + 1);
						state.s = d.format('Y');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					},
					
					decrement: function(element, state) {
						var d = new Date(element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setFullYear(d.getFullYear() - 1);
						state.s = d.format('Y');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					}
				},
				
				/* Hour */ {
					render: function(date) {
						return { value: date.format('g'), after: ':' }
					},
					
					initState: function() {
						return {
							s: ""
						}
					},
					
					keypress: function(element, state, event) {
						if (event.type == 'backspace') {
							state.s = state.s.substring(0, state.s.length - 1);
						} else {
							if (String.fromCharCode(event.charCode) == ':') {
								nextSegment(element, event);
								return;
							}
							
							if ('0'.charCodeAt(0) <= event.charCode && '9'.charCodeAt(0) >= event.charCode)
								state.s = String(state.s) + String.fromCharCode(event.charCode);
							
							if (state.s.length > 2)
								state.s = state.s.substring(state.s.length - 2);
							if (Number(state.s) > 12)
								state.s = state.s.substring(1);
						}
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();						
						
						var nr = Number(state.s);
						if (d.format('A') == 'AM') {
							if (nr == 12) nr = 0;
						} else {
							if (nr != 12) nr += 12;
						}
						d.setHours(nr);
						selectSegment(d, element);
						initCalendar(element.value, cid, options);
						event.preventDefault();
					},
					
					increment: function(element, state) {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setHours(d.getHours() + 1);
						state.s = d.format('g');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					},
					
					decrement: function(element, state) {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();
						d.setHours(d.getHours() - 1);
						state.s = d.format('g');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					}
				},
				
				/* Minute */ {
					render: function(date) {
						return { value: date.format('i'), after: ' ' }
					},
					
					initState: function() {
						return {
							s: ""
						}
					},
					
					keypress: function(element, state, event) {
						if (event.type == 'backspace') {
							state.s = state.s.substring(0, state.s.length - 1);
						} else {
							if (' aApP'.indexOf(String.fromCharCode(event.charCode)) != -1) {
								nextSegment(element, event);								
								return String.fromCharCode(event.charCode) != ' ';
							}
							
							if ('0'.charCodeAt(0) <= event.charCode && '9'.charCodeAt(0) >= event.charCode)
								state.s = String(state.s) + String.fromCharCode(event.charCode);
							
							if (state.s.length > 2)
								state.s = state.s.substring(state.s.length - 2);
							if (Number(state.s) > 59)
								state.s = state.s.substring(1);
						}
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();						
						
						var nr = Number(state.s);
						d.setMinutes(nr);
						selectSegment(d, element);
						initCalendar(element.value, cid, options);
						event.preventDefault();
					},
					
					increment: function(element, state) {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();
						var mr = d.getMinutes() / options.minuteRoundStepTo;
						mr = Math.round(mr) * options.minuteRoundStepTo;
						mr += options.minuteStep;
						d.setMinutes(mr);
						state.s = d.format('i');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					},
					
					decrement: function(element, state) {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();
						var mr = d.getMinutes() / options.minuteRoundStepTo;
						mr = Math.round(mr) * options.minuteRoundStepTo;
						mr -= options.minuteStep;
						d.setMinutes(mr);
						state.s = d.format('i');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					}
				},
				
				/* am/pm */	{
					render: function(date) {
						return { value: date.format('A'), after: '' }
					},
					
					initState: function() {
						return {
							s: ""
						}
					},
					
					keypress: function(element, state, event) {
						if (event.type == 'backspace') {
							state.s = state.s.substring(0, state.s.length - 1);
						} else {
							if (String.fromCharCode(event.charCode).toLowerCase() == 'a')
								state.s = 'A'
							else if (String.fromCharCode(event.charCode).toLowerCase() == 'p')
								state.s = 'P';
							else if (String.fromCharCode(event.charCode).toLowerCase() == 'm' && state.s.length == 1)
								state.s = state.s + 'M';
						}
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();						
						if (state.s.length) {
							if (state.s.charAt(0) == 'A') {
								d.setHours(d.getHours() % 12);
							} else {
								d.setHours(12 + (d.getHours() % 12));
							}
						}
						selectSegment(d, element);
						initCalendar(element.value, cid, options);
						event.preventDefault();
					},
					
					increment: function(element, state) {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + element.value);
						if (isNaN(d)) d = newInitialDate();
						var h = d.getHours();
						var is_pm = h >= 12;
						h = h % 12;
						if (!is_pm)
							h += 12;
						d.setHours(h);
						state.s = d.format('A');
						selectSegment(d, element, true);
						initCalendar(element.value, cid, options);
					},
					
					decrement: function(element, state) {
						this.increment(element, state);
					}
				}
			]
			
			if (whichMode == 'date') segments = [segments[0], segments[1], segments[2]];
			else if (whichMode == 'time') segments = [segments[3], segments[4], segments[5]];
			
			state = segments[0].initState();

			$(this).off('.datepicker').on('backspace.datepicker keypress.datepicker', function(event) {
				// console.log('keypress: ' + String.fromCharCode(event.charCode));	
				var r;
				// If the
				do {
					r = segments[seg].keypress(this, state, event);
				} while (r == true);
			}).on('keydown.datepicker', function(event) { 
				// console.log(event.keyCode);
				if (event.keyCode == 8) { // VK_BACKSPACE
					$(this).triggerHandler('backspace.datepicker', $.Event('backspace', { backspace: true }));
					event.preventDefault();
				}
				else if (event.keyCode == 39) {
					seg = Math.min(segments.length - 1, seg + 1);
					state = segments[seg].initState();
					var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
					if (isNaN(d)) d = newInitialDate();
					selectSegment(d, this, true);
					event.preventDefault();
				}

				if (event.keyCode == 37) {
					seg = Math.max(0, seg - 1);
					state = segments[seg].initState();
					var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
					if (isNaN(d)) d = newInitialDate();
					selectSegment(d, this, true);
					event.preventDefault();
				}

				if (event.keyCode == 9) {
					if (event.shiftKey) {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
						if (isNaN(d)) d = newInitialDate();
						selectSegment(d, this, true);
						if (seg == 0) return;
						event.preventDefault();
						seg = Math.max(0, seg - 1);
						state = segments[seg].initState();
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
						if (isNaN(d)) d = newInitialDate();
						selectSegment(d, this, true);
					} else {
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
						if (isNaN(d)) d = newInitialDate();
						selectSegment(d, this, true);
						if (seg == (segments.length - 1)) return;
						event.preventDefault();
						seg = Math.min(segments.length - 1, seg + 1);
						state = segments[seg].initState();
						var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
						if (isNaN(d)) d = newInitialDate();
						selectSegment(d, this, true);
					}
				}

				if (event.keyCode == 38) {
					segments[seg].increment(this, state);
					event.preventDefault();
				}
				if (event.keyCode == 40) {
					segments[seg].decrement(this, state);
					event.preventDefault();
				}
			});

			var d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
			if (isNaN(d)) d = newInitialDate();
			setTimeout(function() { selectSegment(d, self); }, 0);
			initCalendar(this.value, cid, options);
	
	
			$(this).on('refresh.datepicker', function(event) {
				d = new Date((options.mode == 'time' ? 'January 1 2000 ' : '') + this.value);
				if (isNaN(d)) d = newInitialDate();
				setTimeout(function() { selectSegment(d, self); }, 0);
				initCalendar(this.value, cid, options);
			});
			
			if ($(this).is(':not([required])')) {
				// Add a 'clear' button
				var e = document.createElement('button');
				$(e).addClass('close').html('<span class="material-icons" data-icon="clear"></span>').attr('tabindex', '-1').attr('type', 'button');
				var self = this;
				$(e).click(function() {
					self.value = '';
					$(self).change().blur();
				});
				/* Find the nearest positioned parent... */
				var p = this.offsetParent;
				var adjX = 0, adjY = 0;
				while ($(p).is('body') == false && $(p).css('position') == 'static') {
					adjX += p.offsetLeft;
					adjY += p.offsetTop;
					p = p.offsetParent;
				}
				
				if (p == this.parentNode)
					$(this).after(e);
				else
					$(this.offsetParent).append(e);

				$(e).css({
					height: this.offsetHeight,
					lineHeight: this.offsetHeight + 'px'
				});

				clearButton = e;
				var mb = 0;
				var tp = this.offsetTop + mb + adjY;
				var lp = this.offsetLeft + this.offsetWidth - e.offsetWidth - 5 + adjX;
				$(e).css({
					position: 'absolute',
					top: tp,
					left: lp,
					zIndex: 100
				}).css('float', 'none')
				// console.log(e);
			}
		}).blur(function() {
			var self = this;
			if (hideTimer) clearTimeout(hideTimer);
			hideTimer = setTimeout(function() {
				if (self == calendarFor) {
					$(self).popover('destroy');
					$(self).off('.datepicker');
					calendarFor = null;
					if (clearButton) { $(clearButton).remove(); clearButton = null; }
				}
			}, 500);
		});
		return this;
	};

	$.fn.datepicker = function(options) {
		return this.datetimepicker($.extend({
			mode: 'date'
		}, options || {}));
	};
	// dateFields.datepicker();
})(jQuery);

